export default "__VITE_ASSET__898fd371__"